import styled from 'styled-components'
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #303030;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' | 'danger' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;

  ${props => props.variant === 'primary' ? `
    background-color: #0090D3;
    color: #FFFFFF;
    border: none;
  ` : props.variant === 'danger' ? `
    background-color: #E5484D;
    color: #FFFFFF;
    border: none;
  ` : `
    background-color: #FFFFFF;
    color: #0090D3;
    border: 1px solid #0090D3;
  `}
`

export const Card = styled.div`
  background-color: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #EBEBEB;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
`

export const FormGrid = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 20px;

  &.mt {
    margin-top: 16px;
  }
`

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  font-size: 14px;
`

export const ShortLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding-right: 8px;
  margin-right: 8px;
  border-right: 1px solid #EBEBEB;

  &:last-child {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
  }
`

export const ShortLabelText = styled.span`
  font-weight: normal;
`

export const SeparatorImg = styled.img`
  flex-shrink: 0;
  margin: 0 0.5rem;
`

export const Select = styled.select`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }

  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }
`

export const InfoLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
`

export const InfoPopoverWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 14px;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 20px 0;
`

export const Summary = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;
`

export const SummaryItem = styled.div`
  flex: none;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const KitSummaryLabel = styled(SummaryLabel)`
  color: #000;
  font-weight: 600;
`

export const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
`

export const AddProductContainer = styled.div`
  
`

export const AddButton = styled.div`
  width: 13.9vw;
  min-width: 220px;
  height: 5.9vh;
  min-height: 44px;
  border-radius: 20px;
  border: 1px solid #0090D3;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 20px auto;
`

export const AddButtonImg = styled.img`
  width: 0.8vw;
  min-width: 14px;
  height: 1.7vh;
  min-height: 14px;
  color: #0090D3;
`

export const AddButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #0090D3;
  white-space: nowrap;
`

export const BreadCrumble = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 1rem;
`

export const FirstText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #0090D3;
`

export const SecondText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #696969;
`

export const MoreInformation = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 23vw;
  min-width: 290px;
  height: fit-content;
  padding: 16px;
  border-radius: 0 16px 16px 16px;
  border: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
`

export const InfoName = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #696969;
  display: grid;
  grid-template-columns: 85px 1fr;
  gap: 8px;
  align-items: start;
`

export const InfoValue = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #303030;
  word-break: break-all;
`

export const Input = styled.input`
  padding: 8px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border: 1px solid #cbd5e0 !important;
  }

  &:focus {
    border: 1px solid #3182ce !important;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1) !important;
  }
`

export const InputText = styled.input`
  padding: 8px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border: 1px solid #cbd5e0 !important;
  }

  &:focus {
    border: 1px solid #3182ce !important;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1) !important;
  }
`

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`

export const FileUploadLabel = styled.label`
  padding: 10px 24px;
  background-color: #0090D3;
  color: #FFFFFF;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
`

export const FileNameText = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  font-size: 14px;
`

export const OptionAddRow = styled.div`
  display: flex;
  gap: 8px;
`

export const OptionSelectRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ProductFieldsRow = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  gap: 0;
  font-size: 0.85rem;
  overflow: hidden;
`

export const KitSummaryRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & > :first-child {
    flex: 1;
  }
`

export const KitTrashImg = styled.img`
  cursor: pointer;
  margin-left: 24px;
  flex-shrink: 0;
`

export const ActionIconImg = styled.img`
  cursor: pointer;
`

export const Textarea = styled.textarea<{ hasError?: boolean }>`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  resize: vertical;
  min-height: 80px;

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  margin-top: 4px;
  width: 60px;
  height: 34px;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #0090D3;
    border: 0;
    padding: 2px;
  }

  &:focus + .slider {
    box-shadow: 0 0 1px #0090D3;
  }

  &:checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  border: #696969 2px solid;

  &:before {
    display: block;
    position: relative;
    content: "";
    height: 24px;
    width: 24px;
    left: 5.5px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const KitContainer = styled.div`
  border: 1px solid #EBEBEB;
  border-left: 4px solid #0090D3;
  border-radius: 16px;
  background-color: #F9FBFD;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.02);
`

export const KitHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 12px;
  border-bottom: 1px solid #EBEBEB;
`

export const SubProductCard = styled.div`
  background-color: #FFFFFF;
  border: 1px solid #EBEBEB;
  border-radius: 12px;
  padding: 12px 16px;
  margin-left: 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: -24px;
    top: 50%;
    width: 24px;
    height: 1px;
    background-color: #EBEBEB;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const ModalWrapper = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 95%;
  max-width: 1400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  position: relative;
`

export const CenteredButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 8px;
`

export const ActionOutlineButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background-color: #FFFFFF;
  color: #0090D3;
  border: 1px solid #0090D3;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const ActionSolidButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background-color: #0090D3;
  color: #FFFFFF;
  border: none;
  transition: all 0.2s ease;

  &:hover {
    background-color: #0080C0;
  }
`

export const RoundTrashButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #FFF0F0;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #FFE0E0;
  }

  img, svg {
    width: 18px;
    height: 18px;
    color: #FF4D4D;
  }
`

export const RoundCollapseButton = styled.button<{ isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #FFFFFF;
  border: 1px solid #EBEBEB;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #F9F9F9;
    border-color: #DCDCDC;
  }

  svg {
    width: 16px;
    height: 16px;
    color: #606060;
    transform: rotate(${props => props.isOpen ? '180deg' : '0deg'});
    transition: transform 0.2s ease;
  }
`

export const ItemsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;
`

export const CardProductDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  overflow: hidden;
`

export const CardActionsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  flex-shrink: 0;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const InstallmentsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const InstallmentRow = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 1fr 48px;
  gap: 16px;
  align-items: center;
`

export const HeaderRow = styled(InstallmentRow)`
  & > span {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    color: #303030;
  }
`

export const NumberCell = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #696969;
  text-align: center;
`

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #F87171;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  &:hover {
    color: #DC2626;
  }
`

export const EmptyMessage = styled.p`
  font-family: 'Inter', sans-serif;
  color: #696969;
  font-size: 14px;
`

export const SummaryLine = styled.div<{ mismatch?: boolean }>`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: ${props => (props.mismatch ? '#F87171' : '#303030')};
  font-weight: 700;
`